import React from 'react'

export default ({ email, className }) => {
  if (!email) {
    return null
  }
  return (
    <a className={className} href={`mailto:${email}`} target="_top">
      {email}
    </a>
  )
}
